import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { PlatformAnnouncement, PlatformAnnouncementService } from '../services/platform-announcement.service';

@Component({
  selector: 'app-admin-platform-announcements',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, NzButtonModule, NzCardModule, NzPopconfirmModule, NzTableModule, NzTagModule],
  templateUrl: './admin-platform-announcements.component.html',
  styleUrl: './admin-platform-announcements.component.less',
})
export class AdminPlatformAnnouncementsComponent implements OnInit {
  announcements: PlatformAnnouncement[] = [];
  loading = false;
  updatingId: string | null = null;

  constructor(
    private service: PlatformAnnouncementService,
    private router: Router,
    private message: NzMessageService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.list().subscribe({
      next: (announcements) => {
        this.announcements = announcements || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.message.error(this.translate.instant('ADMIN.PLATFORM_ANNOUNCEMENTS.ERROR_LOAD'));
      },
    });
  }

  create(): void {
    this.router.navigateByUrl('/admin/platform-announcements/new');
  }

  edit(announcement: PlatformAnnouncement): void {
    this.router.navigateByUrl(`/admin/platform-announcements/${announcement._id}`);
  }

  activate(announcement: PlatformAnnouncement): void {
    this.updatingId = announcement._id;
    this.service.activate(announcement._id).subscribe({
      next: () => {
        this.updatingId = null;
        this.message.success(this.translate.instant('ADMIN.PLATFORM_ANNOUNCEMENTS.ACTIVATED'));
        this.load();
      },
      error: () => {
        this.updatingId = null;
        this.message.error(this.translate.instant('ADMIN.PLATFORM_ANNOUNCEMENTS.ERROR_ACTIVATE'));
      },
    });
  }

  deactivate(announcement: PlatformAnnouncement): void {
    this.updatingId = announcement._id;
    this.service.deactivate(announcement._id).subscribe({
      next: () => {
        this.updatingId = null;
        this.message.success(this.translate.instant('ADMIN.PLATFORM_ANNOUNCEMENTS.DEACTIVATED'));
        this.load();
      },
      error: () => {
        this.updatingId = null;
        this.message.error(this.translate.instant('ADMIN.PLATFORM_ANNOUNCEMENTS.ERROR_DEACTIVATE'));
      },
    });
  }

  delete(announcement: PlatformAnnouncement): void {
    this.updatingId = announcement._id;
    this.service.delete(announcement._id).subscribe({
      next: () => {
        this.updatingId = null;
        this.message.success(this.translate.instant('ADMIN.PLATFORM_ANNOUNCEMENTS.DELETED'));
        this.load();
      },
      error: () => {
        this.updatingId = null;
        this.message.error(this.translate.instant('ADMIN.PLATFORM_ANNOUNCEMENTS.ERROR_DELETE'));
      },
    });
  }

  targetLabel(announcement: PlatformAnnouncement): string {
    if (!announcement.targetKind) return this.translate.instant('ADMIN.PLATFORM_ANNOUNCEMENTS.TARGET_NONE');
    return this.translate.instant(`ADMIN.PLATFORM_ANNOUNCEMENTS.TARGETS.${announcement.targetKind.toUpperCase()}`);
  }
}
